export default __webpack_public_path__ + "static/media/Logout.5023e169.svg";